export const formatPrice = (
  priceStart,
  minAbbreviation = '',
  roundPlain = false,
  useThousandsSeparator = false
) => {
  const price = Number(priceStart);
  if (isNaN(price)) return '0';

  const minLevel = {
    'T': 1e12,
    'B': 1e9,
    'M': 1e6,
    'K': 1e3,
    '': 0,
  }[minAbbreviation.toUpperCase()] || 0;

  let formattedValue;

  if (price >= 1e12 && minLevel <= 1e12) {
    formattedValue = (price / 1e12).toFixed(1) + 'T';
  } else if (price >= 1e9 && minLevel <= 1e9) {
    formattedValue = (price / 1e9).toFixed(1) + 'B';
  } else if (price >= 1e6 && minLevel <= 1e6) {
    formattedValue = (price / 1e6).toFixed(1) + 'M';
  } else if (price >= 1e3 && minLevel <= 1e3) {
    formattedValue = (price / 1e3).toFixed(1) + 'K';
  } else {
    // Без префикса
    const plain = roundPlain ? Math.round(price) : price.toFixed(2);
    formattedValue = useThousandsSeparator
      ? Number(plain).toLocaleString('en-US')
      : plain.toString();
  }

  return formattedValue;
};

export const formatWithCommas = (number, options = {}) => {
  const num = Number(number);
  if (isNaN(num)) return number;

  return num.toLocaleString('en-US', options);
};

export const formatPriceFull = (priceStart) => {
  const num = Number(priceStart);
  if (isNaN(num)) return priceStart;

  let minimumFractionDigits = 1;
  let maximumFractionDigits = 1;

  if (num < 100) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 2;
  }
  if (num < 10) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 3;
  }
  if (num < 1) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 5;
  }

  let formatted = formatWithCommas(num, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  formatted = formatted.replace(/(\.\d*?[1-9])0+$/g, '$1');
  formatted = formatted.replace(/\.0+$/g, ''); 

  return formatted;
};
